























































































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import VueToExcel from 'vue-json-excel';
import DatePickerMonthYear from '@/shared/date-picker/date-picker-month-year.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import BillingCustomerAudit from '@/domain/billing/entity/billing-customer-audit.entity';
import Pagination from '@/domain/pagination.entity';
import BillingService from '@/domain/billing/service/billing.service';
import AuditButton from './audit-button.component.vue';
import AuditDatatable from './audit-datatable.component.vue';
import AuditInProcess from './audit-in-process.component.vue';

const formatBoolean = (prop?: boolean): String => {
  if (prop === null || prop === undefined) {
    return '';
  }
  return prop ? 'Sim' : 'Não';
};

@Component({
  components: {
    AuditButton,
    AuditDatatable,
    AuditInProcess,
    DatePickerMonthYear,
    VueToExcel,
    MainButton,
  },
})
export default class BillingModalAuditCustomers extends Vue {
  @Prop({ type: Boolean, default: false })
  private value!: boolean;

  @Prop({ required: true })
  private businessUnitId!: string;

  private competence: string = moment().add(-1, 'months').format('YYYY-MM');

  private customerAudits: BillingCustomerAudit[] = [];

  private loading: boolean = false;

  private hasAuditsAtCompetence: boolean = true;

  private loadingNewAudit: boolean = false;

  private status: string = '';

  private pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'instance|asc',
  });

  private xlsFields: any = {
    Instância: 'instance',
    'Quantidade View': 'amount',
    Contrato: 'contract',
    'Id. Externo': 'contractExternalId',
    'Id. Externo Atual': 'currentContractExternalId',
    Situação: 'status',
    'Realiza Faturamento?': 'performsBilling',
    'Realiza Faturamento na Competência?': 'performsBillingAtCompetence',
    'Situação Fatura Billing': 'invoiceStatus',
    'Quantidade Mês Anterior': 'pastMonthBilledAmount',
    'Valor Faturado do Mês Anterior': 'pastMonthBilledValue',
    'Quantidade Mês Atual': 'currentMonthAmount',
    'Valor Líquido': 'netValue',
    'Valor Detalhado': 'detailValue',
    'Valor Nota': 'billedValue',
    'Valor ERP': 'erpValue',
    'Nº Nota Fiscal ERP': 'erpInvoiceNumber',
  };

  private close(value: boolean): void {
    this.$emit('input', value);
  }

  private doAudit(): void {
    this.loadingNewAudit = true;
    BillingService.performAudit(this.businessUnitId, this.competence)
      .then(this.setCustomerAudits)
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingNewAudit = false);
  }

  @Watch('value')
  private onValueChange() {
    if (this.value) {
      this.customerAudits = [];
      this.loadCustomerAudits();
    }
  }

  private get isProcessing(): boolean {
    return this.status === 'IN_PROCESS';
  }

  private setCustomerAudits({ data }: any) {
    this.customerAudits = data.customerAudits.content.map((it) => new BillingCustomerAudit(it));
    this.pagination.total = data.customerAudits.totalElements;
    this.pagination.pageCount = data.customerAudits.totalPages;
    this.hasAuditsAtCompetence = data.customerAudits.totalElements > 0 && data.status === 'FINISHED';
    this.status = data.status;
  }

  private loadCustomerAudits(): void {
    this.loading = true;
    BillingService.getAudits(this.businessUnitId, this.competence, this.pagination)
      .then(this.setCustomerAudits)
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loading = false });
  }

  updateCompetence(competence: string) {
    this.competence = competence;
    this.loadCustomerAudits();
  }

  get xlsTitle(): string {
    const competenceMoment = moment(this.competence, 'YYYY-MM').locale('pt-BR');
    return `Auditoria de Clientes - ${competenceMoment.format('MMMM')} de ${competenceMoment.format('YYYY')}.xls`;
  }

  updatePagination(pagination: Pagination): void {
    this.pagination = pagination;
    this.pagination.verifyPage();
    this.loadCustomerAudits();
  }

  updateSortBy(sortBy: string[]): void {
    this.pagination.sortBy = sortBy;
    this.loadCustomerAudits();
  }

  updateSortDesc(sortDesc: boolean[]): void {
    this.pagination.sortDesc = sortDesc;
    this.loadCustomerAudits();
  }

  searchAudit() {
    this.loadCustomerAudits();
  }

  recreateAudit() {
    this.loadingNewAudit = true;
    BillingService.performAudit(this.businessUnitId, this.competence)
      .then(this.setCustomerAudits)
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingNewAudit = false);
  }

  exportToXLS(): Promise<BillingCustomerAudit[]> {
    const pagination: Pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    return BillingService.getAudits(this.businessUnitId, this.competence, pagination)
      .then(({ data }: any) => data.customerAudits.content.map((it) => new BillingCustomerAudit({
        ...it,
        performsBilling: formatBoolean(it.performsBilling),
        performsBillingAtCompetence: formatBoolean(it.performsBillingAtCompetence),
      })))
      .catch(VbSnackbarService.handleHttpError);
  }
}
